//hooks
import { useState, useEffect, useRef } from 'react';
import { UserConsumer } from '../../hooks/context/UserContext';
import { useApi } from '../../hooks/useApi';

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "../client/home/Home.module.css";

//mui
import CircularProgress from '@mui/material/CircularProgress';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';
import { DialogProps } from '@mui/material/Dialog';

//mui icons
import ReplayIcon from '@mui/icons-material/Replay';

//tranlsate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//api
import { GetClientBookingApi } from '../../api/booking/GetClientBookingApi';

//component
import CarBookingCard from '../../component/carCard/CarBookingCard';

//type
import { carBookingType } from '../../api/Cars/type/CarsType';
import CarDetailsBooking from '../../popup/carDetails/CarDetailsBooking';
import NoData from '../../component/NoData';

//image
import carPlaceHolder from "../../assets/carPlaceHolder.png"

interface bookingsParamsType {
  page: number;
  per_page: number;
  status?: string;
  time_filter?: string;

}

const Reservations = () => {
    const { t } = useTranslation();
    const [status, setStatus] = useState<string>('');
    const [timeFilter, setTimeFilter] = useState<string>('');
    const [allBooking, setAllBooking] = useState <string>("all");
    const {theme} = UserConsumer();
    const [page, setPage] = useState<number>(1);
    const [lastPage, setLastPage] = useState<number>(1);
    const carsPerPage = 6;
    const [initialLoading, setInitialLoading] = useState<boolean>(true);
    const [initialError, setInitialError] = useState<boolean>(false);
    const [bookingCarsData, setBookingCarsData] = useState<carBookingType[]>([]);
    const loaderRef = useRef<HTMLDivElement | null>(null);
    const [selectedCar, setSelectedCar] = useState<carBookingType | null>(null);
    const [openCarDetailsBooking, setOpenCarDetailsBooking] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
      open:false,
      scrollType: "paper",
    });

    const TIME_FILTERS = [
    { label: t("previous"), value: 'previous' },
    { label: t('current'), value: 'current' },
    { label: t('future'), value: 'future' },
    ];

    const STATUSES = [
    { label: t("pending"), value: 'pending' },
    { label: t("confirmed"), value: 'confirmed' },
    { label: theme === "host" ? t("ready_for_check_in_host") : t("ready_for_check_in"), value: 'ready_for_check_in' },
    { label: theme === "host" ? t("checked_in_host") : t("checked_in"), value: 'checked_in' },
    // { label: theme === "host" ? t("checked_out_host") : t("checked_out"), value: 'checked_out' },
    { label: t("completed"), value: 'completed' },
    { label: t("cancelled"), value: 'cancelled' },
    { label: t("disputed"), value: 'disputed' },
    ];

  const {
    loading: bookingsLoading,
    error: bookingsError,
    HandlerApi: bookingsCars
  } = useApi(GetClientBookingApi, "GET");

  useEffect(() => {
    const fetchData = async (page: number) => {
      const params: bookingsParamsType = {
        page,
        per_page: carsPerPage,
      };
      if (timeFilter) params.time_filter = timeFilter;
      if (status) params.status = status;
      try {
        const resultBookingCars = await bookingsCars(theme, params);
        setLastPage(resultBookingCars.data.last_page);
        setBookingCarsData((prev: any) => {
          const newCars = resultBookingCars.data.data;
          const filteredPrev = prev.filter((car:any) => !newCars.some((element:any) => element.id === car.id));
          const combined = [...filteredPrev, ...newCars];
          return combined;
        });
        setInitialLoading(false);
        setInitialError(false);
      }
      catch (error) {
        setInitialLoading(false);
        if (page === 1) {
          setInitialError(true);
        }
        else {
          setInitialError(false);
        }
      }
      finally {
        setInitialLoading(false);
      }
    };
    fetchData(page);
  }, [page, status, timeFilter]);

  useEffect(() => {
    if (!loaderRef.current){
      return;
    }
    else {
      // It watches an element and tells you:“Is this element visible on the screen right now?”
      const observer = new IntersectionObserver((entries) => {
          const firstEntry = entries[0];
          if (
            firstEntry.isIntersecting &&
            !bookingsLoading &&
            page < lastPage &&
            !bookingsError

          ) {
            setPage((prev) => prev + 1);
          }
        });
      //tells the Intersection Observer:“Watch this element”
      observer.observe(loaderRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [bookingsLoading]); 

  const fetchBookings = async (currentTimeFilter?: string, currentStatus?: string) => {
    const params: bookingsParamsType = {
      page: page,
      per_page: carsPerPage
    };
    if(page === 1) {
      setInitialLoading(true)
    }
    if (currentTimeFilter !== "") {
        params.time_filter = currentTimeFilter;
    }
    if (currentStatus !== "") {
        params.status = currentStatus;
    }
    try {
      const resultBookingCars = await bookingsCars(theme, params);
      setLastPage(resultBookingCars.data.last_page);
      setBookingCarsData((prev: any) => {
        const newCars = resultBookingCars.data.data;
        const filteredPrev = prev.filter((car:any) => !newCars.some((element:any) => element.id === car.id));
        const combined = [...filteredPrev, ...newCars];
        return combined;
      });
      setInitialLoading(false);
      setInitialError(false);
    }
    catch (error) {
      setInitialLoading(false);
      if (page === 1) {
        setInitialError(true);
      }
    }
    finally {
      setInitialLoading(false);
    }
  };
  const handleTimeFilterClick = (value: string) => {
    if (timeFilter !== value) {
      setTimeFilter(value);
      setAllBooking('');
      setPage(1);
      setBookingCarsData([]);
      setInitialLoading(true);
    }
  };

  const handleStatusClick = (value: string) => {
    if (status !== value) {
      setStatus(value);
      setAllBooking('');
      setPage(1);
      setBookingCarsData([]);
      setInitialLoading(true);
    }
  };

  return (
    <div className="sm:p-6 p-3 mt-5">
      <h2 className="uppercase font-bold mb-4 text-gray-700">{t("booking_list")}</h2>
      <div
        onClick={() => {
          if (allBooking !== "all") {
            setAllBooking("all");
            setStatus("");
            setTimeFilter("");
            setPage(1);
            setBookingCarsData([]);
            setInitialLoading(true);
          }
        }}
      className={`w-fit !capitalize p-1 rounded-lg mb-[10px] cursor-pointer 
        ${ allBooking === "all"
                    ? `${theme === "client" ? '!bg-customerColor' : '!bg-paretnerColor'} !text-white`
                    : `!bg-white ${theme === "client" ? '!text-customerColor !border-customerColor' : '!text-paretnerColor !border-paretnerColor'} !border-[1px] !border-solid`
      }`}
      >
        {t("all_bookings")}
      </div>
      {/* Time Filters */}
      <CardActionArea>
        <Swiper
          slidesPerView="auto"
          key={i18n.language}
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
          spaceBetween={20}
          navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          className={`carCardSwiper ${styles.carCardSwiper}`}
        >
          {TIME_FILTERS.map((element) => (
            <SwiperSlide key={element.value} className='!w-fit'>
              <div
                onClick={() => handleTimeFilterClick(element.value)}
                className={`!capitalize p-1 rounded-lg ${
                  element.value === timeFilter
                    ? `${theme === "client" ? '!bg-customerColor' : '!bg-paretnerColor'} !text-white`
                    : `${theme === "client" ? '!text-customerColor !border-customerColor' : '!text-paretnerColor !border-paretnerColor'} !border-[1px] !border-solid`
                }`}
              >
                {element.label}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </CardActionArea>

      {/* Status Filters */}
      <CardActionArea>
        <Swiper
          slidesPerView="auto"
          key={i18n.language}
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
          spaceBetween={20}
          navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          className={`carCardSwiper ${styles.carCardSwiper}`}
        >
          {STATUSES.map((element) => (
            <SwiperSlide key={element.value} className='!w-fit'>
              <div
                onClick={() => handleStatusClick(element.value)}
                className={`!capitalize p-1 rounded-lg ${
                  element.value === status
                    ? `${theme === "client" ? '!bg-customerColor' : '!bg-paretnerColor'} !text-white`
                    : `${theme === "client" ? '!text-customerColor !border-customerColor' : '!text-paretnerColor !border-paretnerColor'} !border-[1px] !border-solid`
                }`}
              >
                {element.label}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </CardActionArea>

      <Box>
        <div>
          {initialLoading
          ?
            <div className='flex justify-center'>
              <CircularProgress/>
            </div>
          :
          <div>
              {initialError //bookingsError
              ?
                <div className='cursor-pointer flex justify-center'>
                  <ReplayIcon onClick={()=>{
                    setPage(1)
                    setBookingCarsData([])
                    fetchBookings(timeFilter, status)
                    }} className='!text-[40px]'/>
                </div>
              : 
              bookingCarsData.length !== 0
              ?
              <>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: "20px" }}>
                  {
                    bookingCarsData.map((element, index) => (
                      <div className='cursor-pointer'
                      key={index}
                      onClick={() => {setOpenCarDetailsBooking({open: true, scrollType: "paper"}); setSelectedCar(element)}}
                      >
                        <CarBookingCard element={element}/>
                      </div>
                    ))
                  }
                </div>
                {page < lastPage && <div ref={loaderRef} style={{ height: "10px" }} />}
                {bookingsLoading && (
                  <div className="flex justify-center mt-4">
                    <CircularProgress size={32}/>
                  </div>
                )}
                {bookingsError && (
                  <div className=" cursor-pointer flex justify-center mt-4">
                    <ReplayIcon onClick={()=>{
                      fetchBookings(timeFilter, status)
                      }} className='!text-[40px]'/>
                  </div>
                )}
              </>
              :<NoData title={t("bookings")} description={t("no_bookings_found")} image={carPlaceHolder}/>
            }
          </div>
          }
        </div>
      </Box>
      {selectedCar && (
        <CarDetailsBooking
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          openCarDetailsBooking={openCarDetailsBooking}
          setOpenCarDetailsBooking={setOpenCarDetailsBooking}
          timeFilter={timeFilter}
          status={status}
          setPage={setPage}
          setBookingCarsData={setBookingCarsData}
          fetchBookings={fetchBookings}
        />
      )} 
    </div>
  );
};
export default Reservations
